import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { sliceToDivisible } from '../../SidebarBlock/layouts/helpers';
import s from './SidebarGrid.scss';
const thumbHeight = parseInt(s['sidebar-thumb-height']);
const thumbWidth = parseInt(s['sidebar-thumb-width']);
const itemsPerRow = 3;
const SidebarGrid = ({ items , renderItem , maxRows =3 , className  })=>{
    const maxItems = itemsPerRow * maxRows;
    const slice = sliceToDivisible(items, itemsPerRow, maxItems);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, slice.map((item, index)=>/*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            key: index,
            value: {
                _rankIndex: index
            }
        }, renderItem({
            item,
            width: thumbWidth,
            height: thumbHeight,
            className: s['grid-item']
        }))));
};
SidebarGrid.displayName = 'SidebarGrid';
export default SidebarGrid;
